import variables from './variables'

import type { AliasToken } from 'antd/es/theme/interface'

const token: Partial<AliasToken> = {
  fontFamily: variables.fontFamily,

  colorText: variables.baseBlack,
  colorTextDisabled: variables.gray60,

  colorPrimary: variables.brandBlue,
  colorSuccess: variables.successGreen,
  colorError: variables.dangerRed,
  colorWarning: variables.warningYellow,

  controlHeightSM: variables.controlSmallSize,
  controlHeight: variables.controlMiddleSize,
  controlHeightLG: variables.controlLargeSize,

  controlItemBgHover: variables.brandBlue20,

  borderRadiusSM: variables.borderRadiusS,
  borderRadius: variables.borderRadius,
  borderRadiusLG: variables.borderRadiusL,

  boxShadow: variables.boxShadow
} as const

export default token
